<template>
  <div
    id="branding-template"
  >
    <h2>
      Template '{{ brandingTemplate.name }}'
    </h2>

    <branding-nav />

    <table class="table">
      <tr>
        <td>
          Description
        </td>
        <td>
          {{ brandingTemplate.description || 'No description available' }}
        </td>
      </tr>
      <tr>
        <td>
          Template Type
        </td>
        <td>
          {{ brandingTemplate.template_type }}
        </td>
      </tr>
      <tr>
        <td>
          Template Mimetype
        </td>
        <td>
          {{ brandingTemplate.template_mimetype }}
        </td>
      </tr>
      <tr>
        <td>
          Template Content
        </td>
        <td
          class="text-right"
        >
          <pre
            class="text-left"
          ><code
            id="template-code"
          >{{ brandingTemplate.template_content }}</code></pre>
          <button
            class="btn btn-warning"
            v-on:click="preview"
          >
            Preview
          </button>
          <button
            class="btn btn-primary"
            v-on:click="toClipboard"
          >Copy</button>
        </td>
      </tr>
      <tr>
        <td>
          Inactive?
        </td>
        <td>
          {{ brandingTemplate.inactive }}
        </td>
      </tr>
      <tr>
        <td>
          Created At
        </td>
        <td>
          {{ brandingTemplate.created_at }}
        </td>
      </tr>
      <tr>
        <td>
          Updated At
        </td>
        <td>
          {{ brandingTemplate.updated_at }}
        </td>
      </tr>
    </table>

    <div
      class="form-group"
    >
      <router-link
        :to="{
          name: 'edit_branding_template',
          params: {
            brandingTemplateId: brandingTemplateId
          }
        }"
        tag="button"
        class="btn btn-primary btn-block"
      >
        Edit Template
      </router-link>
    </div>

    <div
      class="form-group"
    >
      <button
        class="btn btn-danger btn-block"
        v-on:click="deleteBrandingTemplate"
      >
        Delete Template
      </button>
    </div>
  </div>
</template>
<script>
import BrandingNav from '@/components/BrandingNav'

import FlashStore from '@/stores/FlashStore'

import { mapState } from 'vuex'

export default {
  props: {
    brandingTemplateId: {
      type: [ Number, String ],
      default: undefined,
      required: true
    }
  },

  computed: mapState({
    base: state => state.base,
    brandingTemplate: state => state.BrandingTemplateModule.branding_template
  }),

  components: {
    'branding-nav': BrandingNav
  },

  created () {
    this.$store.dispatch(
      'BrandingTemplateModule/getTemplate', this.brandingTemplateId
    ).catch(this.$root.processErrors)
  },

  methods: {
    deleteBrandingTemplate () {
      if (
        confirm('Are you positive you want to delete this template? This action cannot be undone!')
      ) {
        this.$store.dispatch(
          'BrandingTemplateModule/deleteTemplate', this.brandingTemplateId
        ).catch(this.$root.processErrors).then(() => {
          this.$router.push({
            name: 'branding_templates'
          })

          FlashStore.result('This template has been deleted.')
        })
      }
    },

    /* Replace with `PreviewRecipientEmail` component. */
    preview () {
      let win = window.open('', `${this.brandingTemplate.name} Template Preview`, 'resizable,scrollbars,status')
      win.document.write(this.brandingTemplate.template_content)
    },

    toClipboard () {
      navigator.clipboard.writeText(
        document.getElementById('template-code').innerHTML
      )
    }
  }
}
</script>
<style scoped>
pre {
  min-width: calc(50vw);
  max-width: calc(50vw);
  max-height: 12rem;
  min-height: 12rem;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/BrandingTemplate.vue